// @flow

// TODO: @adreyfus remove when included in Sail library
// External libraries
import React from 'react';
import Color from 'tinycolor2';

// SAIL imports
import {TextInput} from 'sail/Input';
import '../../css/ColorPicker.scss';

const TEXT_COLOR_LUMINANCE_THRESHOLD = 0.5;
const DARKEN_RECEIPT_BACKGROUND_COLOR_BY = 1;
const DEFAULT_BACKGROUND_COLOR = '#525f7f';
const HEX_SHORTHAND = /^#?(([0-9]|[a-f]|[A-F])\1+){3}$/;
const HEX = /^#?([a-fA-F0-9]){6}$/;

type ColorPickerProps = {
  hex: ?string,
  onChange: (string) => void,
  disabled?: boolean,
};

type ColorPickerState = {
  color: Color,
  hex: string, // should always be a 6 character string, e.g. 'ab12c3'
  contrastedColor: Color,
  textColor: Color,
  isValid: boolean,
};

type DefaultColorPickerProps = {
  disabled: $PropertyType<ColorPickerProps, 'disabled'>,
};

class ColorPicker extends React.Component<ColorPickerProps, ColorPickerState> {
  static defaultProps: DefaultColorPickerProps = {disabled: false};

  constructor(props: ColorPickerProps) {
    super(props);

    this.state = this.generateStateFromHex(props.hex);
  }

  UNSAFE_componentWillReceiveProps(props: ColorPickerProps) {
    const {hex} = props;
    this.setState(this.generateStateFromHex(hex));
  }

  isValidColor(hex: string): boolean {
    const color = Color(hex);
    return (
      (color.isValid() && color.getFormat() === 'name') ||
      HEX.test(hex) ||
      HEX_SHORTHAND.test(hex)
    );
  }

  generateStateFromHex(hex: ?string): ColorPickerState {
    const isValid = hex ? this.isValidColor(hex) : false;
    let format = 'name';
    if (hex && HEX.test(hex)) {
      format = 'hex6';
    } else if (hex && HEX_SHORTHAND.test(hex)) {
      format = 'hex3';
    }

    const color = Color(hex || DEFAULT_BACKGROUND_COLOR);
    const contrastedColor = color
      .clone()
      .darken(DARKEN_RECEIPT_BACKGROUND_COLOR_BY);
    const textColor = Color(
      color.getLuminance() > TEXT_COLOR_LUMINANCE_THRESHOLD
        ? '#000000'
        : '#FFFFFF',
    );

    return {
      color,
      hex: color.toString(format),
      contrastedColor,
      textColor,
      isValid,
    };
  }

  handleColorChange: (hex: string) => void = (hex) => {
    const {onChange} = this.props;
    if (this.isValidColor(hex)) {
      // If this is a valid hex color, pass it up and rerender.
      this.setState(this.generateStateFromHex(hex));
      onChange(HEX.test(hex) || HEX_SHORTHAND.test(hex) ? `#${hex}` : hex);
    } else {
      // Otherwise, set the hex value (which powers the user text field) and nothing else
      this.setState({hex, isValid: false});
    }
  };

  render(): any {
    const {disabled} = this.props;
    const {hex, color, textColor, isValid} = this.state;

    return (
      <div className="ColorPicker">
        <div
          className="ColorPicker-optionsCardColorPreview"
          style={{
            backgroundColor: color.toHexString(),
            color: textColor.toHexString(),
          }}
        >
          {'#'}
        </div>
        <TextInput
          className="ColorPicker-optionsCardColorInput"
          value={hex.replace('#', '') || ''}
          onChange={this.handleColorChange}
          maxLength={26}
          disabled={disabled}
          invalid={!isValid}
        />
      </div>
    );
  }
}

export default ColorPicker;
